import Image from 'next/image'
import NextLink from 'next/link'
import { useTheme } from 'nextra-theme-docs'
import { useRouter } from 'next/router'
import Logo from './logo.svg'

interface Props {
	to?: string
}

const LogoSection = ({ to }: Props) => {
	const theme = useTheme()
	const router = useRouter()
	let isDark = theme.resolvedTheme === 'dark'
	if (theme.resolvedTheme === undefined) {
		isDark = true
	}
	const filter = isDark ? 'brightness(0) invert(1)' : 'none' // white in dark mode, original in light

	// In Nextra docs pages, the logo is already wrapped in an anchor by the theme.
	// Only wrap in NextLink for non-docs pages to avoid nested <a> tags.
	const isDocsPage = router.pathname.startsWith('/docs')

	const image = <Image src={Logo} alt="Logo" width={80} style={{ filter }} />

	if (isDocsPage) {
		return image
	}

	return (
		<NextLink href={!to ? '/' : to} passHref>
			{image}
		</NextLink>
	)
}

export default LogoSection
